export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_KEY || '';

export const FIRST_DAY = 15;
export const LAST_DAY = 16;
export const YEAR = 2025;
export const LAST_YEAR = 2024;
export const SHORT_YEAR = '`25';

export const streams = {
  1: {
    live: 'https://youtube.com/live/jILWq_hKoT0?feature=share',
    embed: 'https://www.youtube.com/embed/jILWq_hKoT0'
  },
  2: {
    live: 'https://youtube.com/live/yXeKY9VkW2I?feature=share',
    embed: 'https://www.youtube.com/embed/yXeKY9VkW2I'
  },
  3: {
    live: 'https://www.youtube.com/live/hnCYWbipXdQ?feature=share',
    embed: 'https://www.youtube.com/embed/hnCYWbipXdQ'
  },
  4: {
    live: 'https://www.youtube.com/live/TXg95axpJ6k?feature=share',
    embed: 'https://www.youtube.com/embed/TXg95axpJ6k'
  },
  5: {
    live: 'https://youtube.com/live/S_xWt2qGlPI?feature=share',
    embed: 'https://www.youtube.com/embed/S_xWt2qGlPI'
  },
  6: {
    live: 'https://youtube.com/live/nmKKwHghggo?feature=share',
    embed: 'https://www.youtube.com/embed/nmKKwHghggo'
  }
};

export const trackNames = {
  tr1: 'Artificial Intelligence',
  tr2: 'Emerging Future',
  tr3: 'Software Development',
  tr4: 'Architecture and Cloud',
  tr5: 'Security and Digital Identity',
  tr6: 'Lightning Talks and Panel Discussion'
};

export const talkTypes = {
  workshop: 'Interactive 3-hour Hands-on Lab',
  talk: '40-minute Talk (30min+10min Q&A)',
  lightningTalk: '10-minute Lightning Talk'
};

export const cventRegistration =
  'https://web.cvent.com/event/5c0d70b8-de96-4d42-b0cf-35bac112211f/regProcessStep1:482d0019-357c-4887-b079-f976ac1dd643?RefId=Virtual%20Registration&rp=d65d6b25-4980-43c5-8361-64aa3f454652';
export const photosLink = 'https://photos.app.goo.gl/dxD45K6HbuhxMaRQA';
